import { useRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';

import LdsIcon from '../LdsIcon/index.jsx';

import { kebabToPascal } from '../../util/caseUtils.js';

function LdsAlert({
  children,
  dismissible = false,
  iconName,
  id,
  inline = false,
  level = 'info',
  className = '',
  ...rest
}) {
  const ref = useRef(null);

  const getAlertIconName = () => {
    let icon = '';
    switch (level) {
      case ('warning'):
        icon = 'WarningFill';
        break;
      case ('success'):
        icon = 'CheckCircleFill';
        break;
      case ('error'):
        icon = 'WarningCircleFill';
        break;
      default:
        icon = 'InfoFill';
    }
    return iconName || icon;
  };

  const handleClose = () => {
    ref.current.remove();
  };

  const AlertIconElement = () => {
    if (!level) return '';
    return (
      <LdsIcon
        className="lds-alert-icon"
        name={getAlertIconName()}
        label={`${kebabToPascal(level)}`}
      />
    );
  };

  const AlertCloseIcon = () => {
    if (!inline || dismissible) {
      return (
        <button className="lds-button-base lds-alert-button" onClick={handleClose}>
          <LdsIcon label="close" name="X" inline style={{ fill: 'currentcolor' }} />
        </button>
      );
    }
    return '';
  };

  return (
    <div
      id={id}
      className={cn(
        'lds-alert',
        `${level}`,
        {
          inline,
        },
        className
      )}
      ref={ref}
      role="alert"
      aria-live="polite"
      {...rest}
    >
      <div className="lds-alert-message">
        <AlertCloseIcon />
        <AlertIconElement />
        {children}
      </div>
    </div>
  );
}

export default LdsAlert;

LdsAlert.propTypes = {
  dismissible: PropTypes.bool,
  iconName: PropTypes.string,
  id: PropTypes.string.isRequired,
  inline: PropTypes.bool,
  level: PropTypes.oneOf(['info', 'warning', 'error', 'success']),
};
